export default function lazyLoadVideos(lazyVideo: HTMLVideoElement) {
  const supported = "IntersectionObserver" in window;
  if (!supported) return;
  const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(({ isIntersecting, target: video }) => {
      if (isIntersecting && video instanceof HTMLVideoElement) {
        for (let i = 0; i < video.children.length; i++) {
          const videoSource = video.children[i] as HTMLSourceElement;
          if (videoSource) {
            videoSource.src = videoSource.dataset.src;
            video.load();
            video.classList.remove("lazyloadvideo");
            observer.unobserve(video);
          }
        }
      }
    });
  })
  intersectionObserver.observe(lazyVideo);
}